// extracted by mini-css-extract-plugin
module.exports = {"header":"Illustration_header__Bv2d2","picture":"Illustration_picture__7u99l","image":"Illustration_image__lruJ2"};